import { getters } from "@/constants/state";

export default {
  [getters.SWAP_SHIFTS_UNAPPROVED_GETTER]: (state) => state.unapprovedSwapShifts,
  [getters.SWAP_SHIFTS_CONFIRMED_GETTER]: (state) => state.confirmedSwapShifts,
};
